import {
  ABILITIES,
  AGGREGATION_FUNCTIONS,
  FieldValueType,
  OPERATORS_BY_TYPE,
  SEPARATORS_BY_TYPE,
  TYPES,
} from 'modules/reports/lib/Constants'
import type Field from 'modules/reports/store/models/Field'
import type { AbilityType, ConditionType } from 'modules/reports/store/models/types'

export const aggregationFunctions = (field: Field): AGGREGATION_FUNCTIONS[] => {
  const type = field.attributes.type

  if (!hasAbility(field, 'aggregation')) return []

  if (field.isIdentifier) {
    return [AGGREGATION_FUNCTIONS.count]
  }

  switch (type) {
    case TYPES.text:
    case TYPES.date:
      return [AGGREGATION_FUNCTIONS.count, AGGREGATION_FUNCTIONS.concat]

    case TYPES.boolean:
      return [AGGREGATION_FUNCTIONS.concat]

    default:
      return Object.values(AGGREGATION_FUNCTIONS)
  }
}

export const getDefaultAggregationFunction = (field: Field): AGGREGATION_FUNCTIONS | undefined => {
  if (!hasAbility(field, ABILITIES.aggregation)) {
    return undefined
  }

  if (field.isIdentifier) {
    return AGGREGATION_FUNCTIONS.count
  }

  switch (field.attributes.type) {
    case TYPES.number:
    case TYPES.decimal:
      return AGGREGATION_FUNCTIONS.average
    default:
      return AGGREGATION_FUNCTIONS.concat
  }
}

export const hasAbility = (field: Field, ability: AbilityType): boolean => {
  if (field.isIdentifier) {
    return ability === 'aggregation'
  }

  let types: string[]

  switch (ability) {
    case 'aggregation':
      types = [
        TYPES.date,
        TYPES.number,
        TYPES.bytes,
        TYPES.cents,
        TYPES.money,
        TYPES.amount,
        TYPES.hours,
        TYPES.text,
        TYPES.boolean,
      ]
      break

    case 'grouping':
      types = [TYPES.date, TYPES.cohort]
      break

    case 'ordering':
      types = Object.values(TYPES)
      break

    default:
      types = []
  }

  return types.includes(field.attributes.type)
}

export const separatorAfterOperators = (field: Field): string[] => {
  return SEPARATORS_BY_TYPE[field.attributes.type as FieldValueType] || []
}

export const operators = (field: Field): string[] => {
  return OPERATORS_BY_TYPE[field.attributes.type as FieldValueType] || []
}

export const hasDeprecatedPath = (field: Field): boolean => {
  return field.attributes.has_deprecated_path
}

export const conditionType = (field: Field): ConditionType => {
  const type = field.attributes.ui_type || field.attributes.type

  if ([TYPES.date, TYPES.checkbox, TYPES.boolean, TYPES.enum].includes(type)) {
    return type
  }

  return 'text'
}
